var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label":"Correct Text"}},[_c('b-form-textarea',{attrs:{"placeholder":"Write Your Text Here"},on:{"change":_vm.onUpdateAnswer},model:{value:(_vm.correct_text),callback:function ($$v) {_vm.correct_text=$$v},expression:"correct_text"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }